export default function startStepRecorder(browser, extensionId) {
  const iframeWrapper = document.getElementById('one-click-to-notion');
  const iframeElement = document.getElementById('my-iframe');
  const steps = [];
  iframeWrapper.style.display = 'none';

  const stop = () => {
    iframeWrapper.style.display = 'block';
    iframeElement.contentWindow.postMessage({ msg: 'NOTIX_ADD_STEPS', steps }, '*');
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      stop();
    }
  };
  document.body.addEventListener('keydown', handleKeyDown);

  const handleClick = (event) => {
    browser.runtime.sendMessage(extensionId, { takeScreenshot: true }).then((imageUrl) => {
      steps.push({ targetLabel: event.target.innerText, imageUrl });
    });
  };
  document.body.addEventListener('click', handleClick);
  let size = {};
  const box = document.createElement('div');
  box.style.position = 'fixed';
  box.style.zIndex = '9999999';
  box.style.border = '2px solid red';
  box.style.pointerEvents = 'none';
  document.body.appendChild(box);
  let top = 0;
  let left = 0;
  let width = 0;
  let height = 0;
  const padding = 5;
  const handleMouseMove = (event) => {
    size = event.target.getBoundingClientRect();
    console.log(size);
    if (size.top === top && size.left === left && size.width === width && size.height === height) {
      return;
    }
    top = size.top;
    left = size.left;
    width = size.width;
    height = size.height;
    box.style.top = `${top - padding}px`;
    box.style.left = `${left - padding}px`;
    box.style.width = `${width + (2 * padding)}px`;
    box.style.height = `${height + (2 * padding)}px`;
    console.log(box);
  };
  document.body.addEventListener('mousemove', handleMouseMove);
}
